export default __webpack_public_path__ + "static/media/character_04.a6862197.png";